import styled from '@emotion/styled';

export const SectionWrapper = styled.section`
  margin: 3rem 0;
`;
export const Title = styled.h2`
  font-size: 3.6rem;
  font-weight: 900;
  margin-bottom: 2rem;
`;
